import { Link } from "react-router-dom";

const EDITORIAL_PATH = "/om-korthet/redaktionen";

export function formatSwedishDateTime(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("sv-SE", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

interface Props {
  source?: string | null;
  sourceUrl?: string | null;
  publishedAt?: string | null;
  updatedAt?: string | null;
}

/**
 * Artikeltransparens: källa, publiceringstid och att sammanfattningen är
 * AI-genererad under Korthets redaktionella system.
 */
export default function Transparency({ source, sourceUrl, publishedAt, updatedAt }: Props) {
  const published = formatSwedishDateTime(publishedAt);
  const updated =
    updatedAt && updatedAt !== publishedAt ? formatSwedishDateTime(updatedAt) : "";
  const sourceName = source || "originalkällan";

  return (
    <aside className="k2-transparency" aria-label="Källa och AI-transparens">
      <dl className="k2-transparency-list">
        <div>
          <dt>Källa</dt>
          <dd>
            {sourceUrl ? (
              <a href={sourceUrl} target="_blank" rel="noopener noreferrer nofollow">
                {sourceName}
              </a>
            ) : (
              sourceName
            )}
          </dd>
        </div>
        {published && (
          <div>
            <dt>Publicerad</dt>
            <dd>
              <time dateTime={publishedAt ?? undefined}>{published}</time>
            </dd>
          </div>
        )}
        {updated && (
          <div>
            <dt>Uppdaterad</dt>
            <dd>
              <time dateTime={updatedAt ?? undefined}>{updated}</time>
            </dd>
          </div>
        )}
        <div>
          <dt>Sammanfattad av</dt>
          <dd>
            <Link to={EDITORIAL_PATH}>Korthet AI</Link> ·{" "}
            <Link to={EDITORIAL_PATH}>Korthet-redaktionen</Link>
          </dd>
        </div>
      </dl>
      <p className="k2-transparency-note">
        Korthet använder AI för att sammanfatta nyhetsrapportering.{" "}
        {sourceUrl ? (
          <a href={sourceUrl} target="_blank" rel="noopener noreferrer nofollow">
            Läs originalartikeln hos {sourceName}
          </a>
        ) : (
          <>Läs originalartikeln hos {sourceName}</>
        )}{" "}
        för fullständig rapportering.
      </p>
    </aside>
  );
}
